import React, {Component} from 'react';
import {Breadcrumb, Grid, Header, Icon, Statistic} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import DeliveryData from "../../data/DeliveryData";


class DeliveryHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stats: [],
            loading: true
        }
        this.get_total_stat = this.get_total_stat.bind(this)
    }

    componentDidMount() {
        this.initialFetch()
    }

    initialFetch() {
        DeliveryData.deliveryManStatsToday((stats =>{
            console.log(stats)
            this.setState({stats, loading:false})
        }))
    };

    get_total_stat(key){
        let stat = this.state.stats.find((stats) => stats.sale__delivery_state === key )
        if(stat) return stat.total
        return 0
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Bisttros - Inicio</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Inicio</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Grid columns={1}>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Header as='h2' icon textAlign='center'>
                                <Icon name='clock outline'/>
                                <Header.Content>
                                    En el día de hoy
                                </Header.Content>
                            </Header>
                            <Statistic.Group size='small' widths={4} style={{verticalAlign: 'initial', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <Statistic style={{padding:'1em'}}>
                                    <Statistic.Value><Icon name='shipping fast' /> {this.state.loading ? <Icon loading name='spinner' />:this.get_total_stat(3)}</Statistic.Value>
                                    <Statistic.Label>Deliveries Pendientes</Statistic.Label>
                                </Statistic>
                                <Statistic style={{padding:'1em'}}>
                                    <Statistic.Value><Icon name='smile outline' /> {this.state.loading ? <Icon loading name='spinner' />:this.get_total_stat(4)}</Statistic.Value>
                                    <Statistic.Label>Deliveries Entregados</Statistic.Label>
                                </Statistic>
                                <Statistic style={{padding:'1em'}}>
                                    <Statistic.Value><Icon name='user times' /> {this.state.loading ? <Icon loading name='spinner' />:this.get_total_stat(7)}</Statistic.Value>
                                    <Statistic.Label>Deliveries Rechazados</Statistic.Label>
                                </Statistic>
                                <Statistic style={{padding:'1em'}}>
                                    <Statistic.Value><Icon name='cancel' /> {this.state.loading ? <Icon loading name='spinner' />:this.get_total_stat(5)}</Statistic.Value>
                                    <Statistic.Label>Deliveries Anulados</Statistic.Label>
                                </Statistic>
                            </Statistic.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default DeliveryHome;



// WEBPACK FOOTER //
// ./src/containers/home/DeliveryHome.js